/* globals chrome */

export const TWILIO_SUPPORTED_CHROME_BASED_BROWSERS = [
  'edg',
  'edge',
  'electron',
  'headlesschrome',
];

export const getUserAgent = () => (typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string'
  ? navigator.userAgent
  : null
);

export const getPlatform = () => (typeof navigator !== 'undefined' && typeof navigator.platform === 'string'
  ? navigator.platform
  : null
);

export const guessBrowser = (userAgent) => {
  if (typeof userAgent === 'undefined') {
    userAgent = getUserAgent();
  }
  if (/Chrome|CriOS/.test(userAgent)) {
    return 'chrome';
  }
  if (/Firefox|FxiOS/.test(userAgent)) {
    return 'firefox';
  }
  if (/Safari/.test(userAgent)) {
    return 'safari';
  }
  return '';
};

export const guessDevice = (userAgent, platform) => {
  const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
  const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
  if (typeof userAgent === 'undefined') {
    userAgent = getUserAgent();
  }
  if (typeof platform === 'undefined') {
    platform = getPlatform();
  }
  if (/android/i.test(userAgent)) {
    return 'Android';
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'IOS';
  }
  if (macosPlatforms.indexOf(platform) !== -1) {
    return 'Mac';
  }
  if (windowsPlatforms.indexOf(platform) !== -1) {
    return 'Windows';
  }
  if (/Linux/.test(platform)) {
    return 'Linux';
  }
  return 'Desktop';
};

export const isWebRTCSupported = () => typeof navigator === 'object'
    && typeof navigator.mediaDevices === 'object'
    && typeof navigator.mediaDevices.getUserMedia === 'function'
    && typeof RTCPeerConnection === 'function';

export const isNonChromiumEdge = (browser) => browser === 'chrome' && /Edge/.test(navigator.userAgent) && (
  typeof chrome === 'undefined' || typeof chrome.runtime === 'undefined'
);

const getParenthesizedSubstrings = (string) => {
  const openParenthesisPositions = [];
  const substrings = [];
  for (let i = 0; i < string.length; i += 1) {
    if (string[i] === '(') {
      openParenthesisPositions.push(i);
    } else if (string[i] === ')' && openParenthesisPositions.length > 0) {
      const openParenthesisPosition = openParenthesisPositions.pop();
      if (openParenthesisPositions.length === 0) {
        substrings.push(string.substring(openParenthesisPosition, i + 1));
      }
    }
  }
  return substrings;
};

export const rebrandedChromeBrowser = (browser) => {
  // If the browser is not Chrome based, then it is not a rebranded Chrome browser.
  if (browser !== 'chrome') {
    return null;
  }

  // Latest desktop Brave browser has a "brave" property in navigator.
  if ('brave' in navigator) {
    return 'brave';
  }

  const parenthesizedSubstrings = getParenthesizedSubstrings(navigator.userAgent);
  const nameAndVersions = parenthesizedSubstrings.reduce(
    (userAgent, substring) => userAgent.replace(substring, ''),
    navigator.userAgent,
  );

  // Extract the potential browser <name>s by ignoring the first two names, which
  // point to <source> and <engine>.
  const matches = nameAndVersions.match(/[^\s]+/g) || [];
  const [/* source */, /* engine */, ...browserNames] = matches.map((nameAndVersion) => nameAndVersion.split('/')[0].toLowerCase());

  // Extract the <name> that is not expected to be present in the vanilla Chrome
  // browser, which indicates the rebranded name (ex: "edg[e]", "electron"). If null,
  // then this is a vanilla Chrome browser.
  return browserNames.find((name) => !['chrome', 'mobile', 'safari'].includes(name)) || null;
};
